export default state => ({
  ...state,
  isLoading: true,
});
